// Splide init
// function mmInitSplide() {
//     const id = ".splide-mm-cart";
//     const splideElem = document.querySelector(id);

//     if (splideElem) {
//         new Splide(splideElem, {
//           type: "slide",
//           arrows: false,
//           pagination: false,
//           rewind: false,
//           destroy: false,
//           gap: 27,
//           perPage: 1,
//           autoHeight: true,
//           drag: "free",
//           width: 217,
//           height: "100%",
//           direction: "ttb",
//           breakpoints: {
//             768: {
//               destroy: true,
//             },
//           },
//         }).mount();
//     }
// }

function mmInitSplideMobile() {
    const idMobile = ".mm-splide-crossell";
    const splideElemMobile = document.querySelector(idMobile);

    if (splideElemMobile) {
      let splide = new Splide(splideElemMobile, {
        type: "splide",
        arrows: false,
        pagination: false,
        rewind: false,
        gap: "12px",
        perPage: 1,
        destroy: true,
        padding: {
          right: "150px",
        },
        breakpoints: {
          768: {
            destroy: false,
            padding: {
              right: "40px",
            },
          },
        },
      }).mount();

      let splideContainer = splideElemMobile.closest('.mm-dc-cross-sell');

      let arrowNext = splideContainer.querySelector('.mm-arrow-right')
      let arrowPrev = splideContainer.querySelector('.mm-arrow-left')


      arrowNext.addEventListener("click", function(){
          splide.go( '+1' );
        });
      arrowPrev.addEventListener("click", function(){
          splide.go( '-1' );
        });


    }
}

function mmInitSplideTestimonials() {
    const id = ".mm-dc-testimonials";
    const splideElem = document.querySelector(id);

    if (splideElem) {
        new Splide(splideElem, {
            type: "loop",
            arrows: false,
            pagination: true,
            gap: 20,
            autoplay: true,
            interval: 2000,
            perPage: 1,
            padding: {
                right: "0",
                left: "0",
            },
        }).mount();
    }
}

document.addEventListener(
    "DOMContentLoaded",
    () => {
        // mmInitSplide();
        mmInitSplideMobile();
        mmInitSplideTestimonials();
        //mmOpenCart();
        // mmGetFreeProductsVariantId();
    },
    { once: true }
);

// Debounce
// https://redd.one/blog/debounce-vs-throttle
// If function is called several times in {duration},
// wait for a pause longer than {duration} to actually trigger it.
// eg, wait 500 milliseconds after last call to actually call doSomething():
// debounce(function () {
//    doSomething();
//  }, 500)
function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

function mmCartSectionElement() {
    return document.getElementById("shopify-section-mm-cart");
}

function mmCartProductsContainerElement() {
    return mmCartSectionElement().querySelector(".mm-dc-products-container");
}

function mmCartItem(productVariantId) {
    return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
    const itemEl = mmCartItem(productVariantId);

    return itemEl.querySelector("[data-item-quantity]");
}

function mmGetCartItemQuantity(productVariantId) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);

    return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
    // Display qtty in front
    if (newQuantity >= 0) {
        const quantityEl = mmCartItemQuantityEl(productVariantId);

        quantityEl.dataset.itemQuantity = newQuantity;
        quantityEl.innerText = newQuantity;


    }
}

function mmCartHTMLFromData(data) {
    const el = document.createElement("DIV");
    el.innerHTML = data.sections["mm-cart"];

    return el;
}

function extractItemsFromCartHTML(data) {
    const el = mmCartHTMLFromData(data);
    return el.querySelector(".mm-dc-products-container");
}

function insertCartProductsFromResponse(data) {
    const itemsContainer = extractItemsFromCartHTML(data);
    mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

    return data;
}

function extractTotalPriceFromCartHTML(data) {
    const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
    return cartEl.querySelector("[data-cart-total-price]");
}

function insertInsertTotalPriceFromResponse(data) {
    const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
    const currentTotalPriceEl = mmCartSectionElement().querySelector("[data-cart-total-price]");
    currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;

    return data;
}

function mmAPIRequest(method, path, body) {
    document.querySelector(".mm-dc-products")?.classList?.add("mm-inactive");
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    })
        .then((response) => response.json())
        .then((data) => {
            document.querySelector(".mm-dc-products")?.classList?.remove("mm-inactive");
            updateCartCount(data.item_count != null ? data.item_count : 0);
            if (data.status && data.status > 400) {
                throw data;
            } else {
                return data;
            }
        });
}

// récupérer le panier
function mmGetCart() {
    return mmAPIRequest("GET", "cart.js");
}

// Ouvrir le panier
function mmOpenCart() {
    mmGetCart();
    document.querySelector(".mm-drawer-cart-filter").classList.add("mm-dc-is-open");
    document.querySelector("html").classList.add("stop-scrolling");
}

// Ouvrir et refresh le panier (utilisé pour faire fonctionner les babybox et superbox avec le panier)
function mmOpenAndRefreshCart() {
    function handleResponse() {
        const newCartEl = document.createElement("DIV");
        newCartEl.innerHTML = this.responseText;
        const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
        innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-filter").innerHTML;
        // mmInitSplide();
        mmInitSplideMobile();
        mmInitSplideTestimonials();
        document.querySelector(".mm-drawer-cart-filter").classList.add("mm-dc-is-open");
        document.querySelector("html").classList.add("stop-scrolling");
    }
    // Construction de l'URL en fonction de la langue
    const rootUrl = document.querySelector(".mm-drawer-cart-filter").dataset.localization;
    
    let url;
    if (rootUrl == '/') {
        url = `/?section_id=mm-cart`;
    } else {
        url = `${rootUrl}/?section_id=mm-cart`;
    }

    const request = new XMLHttpRequest();
    request.addEventListener("load", handleResponse);
    request.open("GET", url, true);
    request.send();
}

// Fermer le panier
function mmCloseCart() {
    document.querySelector(".mm-drawer-cart-filter").classList.remove("mm-dc-is-open");
    document.querySelector("html").classList.remove("stop-scrolling");
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
    const newCartEl = document.createElement("DIV");
    newCartEl.innerHTML = data.sections["mm-cart"];
    const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
    innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-filter").innerHTML;
    // mmInitSplide();
    mmInitSplideMobile();
    mmInitSplideTestimonials();
    return data;
}

// Ajouter un item au panier
function mmAddProductToCart(productId, { quantity = 1, openCart = true }, selling_plan_id = '') {
  const item = {
      quantity: quantity,
      id: productId
  };
    if (selling_plan_id) {
      item.selling_plan = selling_plan_id;
    }

    mmAPIRequest("POST", "cart/add.js", {
        items: [item],
        sections: "mm-cart",
    })
    .then(refreshCartFromData)
    .then(mmAddOrRemoveFreeProducts)
    .then(() => {
        if (openCart) {
            setTimeout(mmOpenCart);
        }
    })
    .catch((error) => {
        mmCartProductsContainerElement().innerHTML = `
            Oups, il y a eu une erreur, essayez de recharger la page !
        `;
        mmOpenCart();
        console.log(error);
    });
}

function mmIncreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity + 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity - 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroyProductFromCart(productVariantId) {
    const newQuantity = 0;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmPushNewQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);

    mmAPIRequest("POST", "cart/change.js", {
        id: productVariantId.toString(),
        quantity: quantity,
        sections: "mm-cart",
    })
        .then(mmAddOrRemoveFreeProducts)
        .then(refreshCartFromData);
}

function mmChangeFreeProductInCart(productVariantIdToAdd, productVariantIdToRemove, clickedElem) {
    // Debounce sur le CTA
    clickedElem.innerText = "AJOUTÉ !";
    clickedElem.classList.add("mm-disabled");

    mmAPIRequest("POST", "cart/add.js", {
        items: [{ quantity: 1, id: productVariantIdToAdd }],
        sections: "mm-cart",
    }).then(mmDestroyProductFromCart(productVariantIdToRemove));
}

const mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
    mmPushNewQuantity(productVariantId);
}, 300);

function mmAddOrRemoveFreeProducts(data) {
    if (data.sections["mm-cart"]) {
        const el = mmCartHTMLFromData(data);
        const freeProductEls = el.querySelector("[data-free-products]");
        let freeProductCounts = 0;

        // creates an object like { 44058675: 1, 44058001: 0 }
        // where key is free product id and value, its quantity
        const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
            const productId = freeProductEl.dataset.variantId;
            const isFree = freeProductEl.dataset.freeProduct == "true";
            const itemEl = mmCartItem(productId);
            if (isFree) {
                freeProductCounts += 1;
            }
            if (itemEl && isFree) {
                console.log("do nothing, item is already added");
                // do nothing, item is already added
            } else if (itemEl && !isFree) {
                console.log("item is present but should be removed");
                // item is present but should be removed
                param[productId] = 0;
            } else if (!itemEl && isFree) {
                console.log("item is absent but should be added", productId);
                // item is absent but should be added
                param[productId] = 1;
            }
            return param;
        }, {});

        // Add or remove free products only if needed
        if (Object.keys(productsParams).length > 0) {
            mmAPIRequest("POST", "cart/update.js", { updates: productsParams, sections: "mm-cart" }).then(refreshCartFromData);
        }
    }
    return data;
}

function mmAddFreeProductToCart(productId, { quantity = 1, openCart = true }, clickedElem) {
    // Debounce sur le CTA
    clickedElem.innerText = "AJOUTÉ !";
    clickedElem.classList.add("mm-disabled");

    // Ajouter le free product
    mmAddProductToCart(productId, { openCart: false });
}

//Show selling plan
function toggleSellingPlan(checkbox){
  const productCard = checkbox.closest(".mm-dc-product-container");
  const subContainer = checkbox.closest(".mm-dc-cart-item-subscribe-container");
  const subSelectContainer = subContainer.querySelector(".mm-dc-select-selling-plan-container");
  const line = parseInt(subContainer.dataset.itemLine);

  if (checkbox.checked) {
    const selling_plan = subSelectContainer.querySelector('select').value;
    subSelectContainer.classList.remove('hidden')
    updateSellingPlan(line, productCard, selling_plan);

  } else {
    subSelectContainer.classList.add("hidden");
    updateSellingPlan(line, productCard, null);
  }
}

//Change Selling Plan
function updateSellingPlan(line, productCard,  sellingPlan) {
  const quantity = parseInt(productCard.querySelector("[data-item-quantity]").innerText);

  // Objet attendu par Shopify
  let payload = {
    line: line, // Ligne dans le panier
    quantity: quantity,   // Quantité de la ligne
    selling_plan: sellingPlan // Null ou ID du plan
  };


  mmAPIRequest("POST", "cart/change.js", payload)
    .then(mmOpenAndRefreshCart)
    .catch((error) => {
      mmCartProductsContainerElement().innerHTML = `
          Oups, il y a eu une erreur, essayez de recharger la page !
      `;
      console.log("Erreur API Shopify:", error);
    });
}

window.addEventListener("DOMContentLoaded", (event) => {
    mmGetCart();
});

function updateCartCount(value) {
    const cartCounterElement = document.querySelector(".mm-header-cart-container .cart-counter");
    const cartCountBubble = document.querySelector('.mm-cart-count-bubble');

    if (cartCounterElement) {
        cartCounterElement.innerText = value;
        cartCounterElement.style.display = value === 0 ? 'none' : 'inline-block';
    }

    if (cartCountBubble) {
        cartCountBubble.style.display = value === 0 ? 'none' : 'flex';
    }
}
